import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" (15) ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" (15) ")
const _hoisted_3 = { class: "time" }
const _hoisted_4 = { class: "play-time" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_6 = { class: "duration-time" }

import { library } from '@fortawesome/fontawesome-svg-core'
  import { faBackward, faForward, faPlay, faPause, faStepBackward } from '@fortawesome/free-solid-svg-icons'
  import { format_time } from '@/utils/FormatTime'
  import { HowlPlayer } from '@/utils/HowlPlayer'
  import { computed, ComputedRef, onUnmounted, reactive, ref, Ref, watch } from 'vue'

  interface Props {
    file_path: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    file_path: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
    file_path: string;
  }
  library.add(faBackward, faForward, faPlay, faPause, faStepBackward);

  

  const player = reactive(new HowlPlayer(props.file_path));
  player.setup();

  const playing: ComputedRef<boolean> = computed((): boolean => player.isPlaying() );
  const disabled: ComputedRef<boolean> = computed((): boolean => player.isError() );
  const formattedCurrentTime: ComputedRef<string> = computed((): string => format_time(player.getCurrentTime()) );
  const formattedDuration: ComputedRef<string> = computed((): string => format_time(player.getDuration()) );

  const sliderMax = 10000;
  const seek: Ref<number> = ref(0);
  watch(
    () => player.getCurrentTime(),
    (value: number): void => {
      seek.value = value / player.getDuration() * sliderMax;
    }
  );
  const handleSeekChange = (position: number): void => {
    const time = player.getDuration() * (position / sliderMax)
    player.seek(time);
  }

  const rates = [
    { value: 0.5,  label: '0.5X' },
    { value: 0.75, label: '0.75X'},
    { value: 1,    label: '1X'   },
    { value: 1.25, label: '1.25X'},
    { value: 1.5,  label: '1.5X' },
    { value: 1.75, label: '1.75X'},
    { value: 2,    label: '2X'   },
  ];
  const rate: Ref<number> = ref<number>(1);
  const handleRateChange = (value: number): void => {
    player.rate(value);
  };

  onUnmounted(() => {
    player.unload();
  });

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_fa = _resolveComponent("fa")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_slider, {
      modelValue: seek.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((seek).value = $event)),
      onChange: handleSeekChange,
      min: 0,
      max: sliderMax,
      "show-tooltip": false,
      disabled: _unref(disabled)
    }, null, 8, ["modelValue", "disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(player).seek(0))),
      disabled: _unref(disabled)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_fa, { icon: "step-backward" })
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(player).back())),
      disabled: _unref(disabled)
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_fa, { icon: "backward" })
      ]),
      _: 1
    }, 8, ["disabled"]),
    (!_unref(playing))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(player).play())),
          disabled: _unref(disabled)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa, { icon: "play" })
          ]),
          _: 1
        }, 8, ["disabled"]))
      : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(player).pause())),
          disabled: _unref(disabled)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_fa, { icon: "pause" })
          ]),
          _: 1
        }, 8, ["disabled"])),
    _createVNode(_component_el_button, {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(player).forward())),
      disabled: _unref(disabled)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_fa, { icon: "forward" }),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_select, {
      modelValue: rate.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((rate).value = $event)),
      onChange: handleRateChange,
      class: "rate-pulldown",
      disabled: _unref(disabled)
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rates, (rate) => {
          return _createVNode(_component_el_option, {
            key: rate.value,
            label: rate.label,
            value: rate.value
          }, null, 8, ["label", "value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formattedCurrentTime)), 1),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formattedDuration)), 1)
    ])
  ]))
}
}

})